export const canComment = false;
export const CREATE_NEW_ITEM = "new"
export const CREATE_NEW_ITEM_PATH = "new"
export const VERSIONS_PATH = "/versions"
export const DISABLED_OPACITY = 0.3
export const NEW_ITEM_ID = "new_item_id"
export const DISH_CO2_IMPACT_DEFAULT = "3"
export const DATE_QUERY_PARAM = "date"
export const MIN_PASSWORD_LENGTH = 8


export const USER_GROUP_SYSTEM_ADMIN = "system_admin_users"
export const USER_GROUP_COMPANY_MANAGER = "company_manager_users"
export const USER_GROUP_OFFICE_MANAGER = "office_manager_users"
export const USER_GROUP_KITCHEN_MANAGER = "KITCHEN_manager_users"
export const USER_GROUP_EATER_GROUP_ADMIN = "eater_group_admin_users"
export const USER_GROUP_EATER = "eater_users"
